import { ExporterPropertyValueMap } from "./export-configuration";
import { ExportDestinationsMap } from "./export-destinations";
import { z } from "zod";
export const PipelineEventType = z.enum([
    "OnVersionReleased",
    "OnHeadChanged",
    "OnSourceUpdated",
    "OnDocumentationPublished",
    "None",
]);
export const PipelineDestinationGitType = z.enum([
    "Github",
    "Gitlab",
    "Bitbucket",
    "Azure",
]);
export const PipelineDestinationExtraType = z.enum([
    "WebhookUrl",
    "S3",
    "Documentation",
]);
export const PipelineDestinationType = z.union([
    PipelineDestinationGitType,
    PipelineDestinationExtraType,
]);
export const Pipeline = z.object({
    id: z.string(),
    name: z.string(),
    eventType: PipelineEventType,
    isEnabled: z.boolean(),
    workspaceId: z.string(),
    designSystemId: z.string(),
    exporterId: z.string(),
    brandPersistentId: z.string().optional(),
    themePersistentId: z.string().optional(),
    themePersistentIds: z.string().array().optional(),
    contextIds: z.string().array().optional(),
    exporterPropertyValues: ExporterPropertyValueMap.optional(),
    isExporterDeprecated: z.boolean(),
    // Destinations
    ...ExportDestinationsMap.shape,
});
